/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name shiftday
 */
angular.module('mercury.modules.time.roster')
.directive('shiftday', ["$timeout", "reporttime", "$stateParams", function($timeout, reporttime, $stateParams) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element) {
      var editorBody;
      var dragDelay;

      // If the cell has to be disabled because the roster that the cell belongs
      // to is published then we don't want the week-cell class and we also don't
      // want the user to be able to click on the cell and keep adding/updating
      // shifts
      var disableEvents = scope.disableCell(scope.viewStartDateTime);
      if (disableEvents) {
        element.removeClass('day-row');
      }

      var isMobile = function() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
      };

      dragDelay = isMobile() ? 500 : 0;
      editorBody = angular.element('#editor-container');

      var roundMinutes = function(input) {
        var interval = 15;
        return Math.round(input / interval) * interval;
      };

      var shiftLeftPosition = function(clockintime) {
        // Get the number of minutes after the start of the grid day that the shift starts
        // this is then used to determine how far left (i.e. away from the start of the
        // grid day) the shift should be positioned.
        //
        // Note that this needs to handle shifts being on different chronological days
        // but the same company day. E.g. a company start time of 7am, and a shift
        // starting at 1am Tuesday. This shift appears on the Monday 'day' on the roster.
        //
        // We rely on Moment's behaviour of setting the day() as an integer value also
        // updating the date to the _current week_. This means the grid we can compare
        // roster template days that have a completely different start _date_ to the view
        // start date, and still get the correct positioning - we only care about the day
        // portion of the clockin.
        const clockinMoment = moment(clockintime);
        const viewStartMoment = moment(scope.viewStartDateTime);

        const clockinDay = clockinMoment.day(); // e.g. Tuesday (1am start)
        const viewDay = viewStartMoment.day(); // e.g. Monday (7am start, 7am Tuesday end)

        const numberOfMinutesAfterDayStart = clockinMoment.clone().day(clockinDay)
          .diff(viewStartMoment.clone().day(viewDay), 'minutes');

        var percentDayStart = (numberOfMinutesAfterDayStart / 1440) * 100;
        return percentDayStart + '%';
      };

      var shiftWidth = function(clockintime, clockouttime) {
        var clockinMoment = moment(clockintime);
        var clockoutMoment = moment(clockouttime);
        var shiftLengthMinutes = clockoutMoment.diff(clockinMoment, 'minutes');
        var percentDayLength = (shiftLengthMinutes / 1440) * 100;
        // 1px is subtracted to account for the border, making things line up nicely
        return 'calc(' + percentDayLength + '% - 1px)';
      };

      var setPosition = function() {
        element.css({
          'width': shiftWidth(scope.shift.clockinTime, scope.shift.clockoutTime),
          'left': shiftLeftPosition(scope.shift.clockinTime),
          'top': '0px',
        });
      };

      setPosition();

      // If the shifts clockin or out time changes, reset the position of the shift.
      scope.$watch('shift.clockinTime', function() {
        if (element.hasClass('ui-draggable-dragging') === false) {
          setPosition();
        }
      });
      scope.$watch('shift.clockoutTime', function() {
        if (element.hasClass('ui-draggable-dragging') === false) {
          setPosition();
        }
      });

      var shiftClick = function() {
        scope.openEditDialog({
          shifts: scope.shift,
          staff: scope.staff,
          roles: scope.roles,
          saveCb: scope.save
        });
      };
      element.on('click', shiftClick);

      if (!disableEvents) {
        /*
        * Configure the draggable shift to enable moving on the day or to a different staff member.
        */
        element.draggable({
          grid: [1, element.height() + 11],
          revert: 'invalid',
          revertDuration: 0,
          containment: editorBody,
          delay: dragDelay,
          start: function(event) {
            if (scope.shift.datestampLocked != null) {
              //This kills the drag
              event.stopPropagation();
              event.preventDefault();
              return;
            }

            jQuery('#editor-body').addClass('dragging');
            element.off('click');
          },
          stop: function(event, ui) {
            var updatedStaffId = ui.helper.data('staffId');
            jQuery('#editor-body').removeClass('dragging');
            if (updatedStaffId) {
              // Record the source staff member so we can perform updates to their overall cost.
              scope.shift.originalStaffMemberId = scope.shift.staffMemberId;
              // Then update the shift to belong to the destination staff member.
              scope.shift.staffMemberId = updatedStaffId;
            }

            scope.updateShift(scope.shift);

            setPosition();

            $timeout(function() {
              element.on('click', shiftClick);
            }, 50);
          },
          drag: function(event, ui) {
            if (scope.shift.datestampLocked != null) {
              //This kills the drag
              event.stopPropagation();
              event.preventDefault();
              return;
            }

            event.stopPropagation();
            var clockinMoment = moment(scope.shift.clockinTime);
            var clockoutMoment = moment(scope.shift.clockoutTime);

            var shiftLength = clockoutMoment.diff(clockinMoment, 'minutes');
            var newStart = roundMinutes(1440 * (ui.position.left / angular.element(ui.helper).parent().width()));

            var newClockin = moment(scope.viewStartDateTime).add(newStart, 'minutes');

            scope.shift.clockinTime = newClockin.format();
            scope.shift.clockoutTime = newClockin.add(shiftLength, 'minutes').format();
          }
        });

        /*
        * Configure the shift as resizable to the lenght of the shift can be changed.
        */
        element.resizable({
          handles: 'e, w',
          containment: 'parent',
          distance: (Math.round((1440 / jQuery('.day-row').width()) * 15) / 2),
          start: function(event) {
            if (scope.shift.datestampLocked != null) {
              //This kills the drag
              event.stopPropagation();
              event.preventDefault();
              return;
            }

            element.off('click');
          },
          stop: function() {
            scope.updateShift(scope.shift);

            $timeout(function() {
              element.on('click', shiftClick);
            }, 50);
          },
          resize: function(event, ui) {
            if (scope.shift.datestampLocked != null) {
              //This kills the drag
              event.stopPropagation();
              event.preventDefault();
              return;
            }
            event.stopPropagation();
            var deltaLeft = ui.position.left - ui.originalPosition.left;
            var handle = (deltaLeft === 0) ? 'right' : 'left';

            var newLengthMinutes = roundMinutes(Math.round(1440 * ((ui.size.width + 10) / angular.element(ui.element).parent().width())));
            var newStartMinutes = roundMinutes(Math.round(1440 * (ui.position.left / angular.element(ui.element).parent().width())));

            var newClockin = moment(scope.viewStartDateTime).add(newStartMinutes, 'minutes');

            if (handle === 'right') {
              scope.shift.clockoutTime = newClockin.add(newLengthMinutes, 'minutes').format();
            } else {
              scope.shift.clockinTime = newClockin.format();
            }

            setPosition();
          }
        });
      }
    }
  };
}]);
